"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SortUp = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.4931464,4.99807161 L11.4963,5.00207161 L11.4998,4.9992 L12.2069068,5.70630678 L12.2043,5.70807161 L15.7423,9.2412 L15.0351932,9.94830678 L11.9993,6.91707161 L12,18.9992 L11.0003,18.9992 L11.0003,6.91207161 L7.96440678,9.94830678 L7.2573,9.2412 L10.7893,5.70907161 L10.7860396,5.70517839 L11.4931464,4.99807161 Z", fillRule: "evenodd" })));
};
SortUp.displayName = 'SortUp';
exports.default = SortUp;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SortUp.js.map